import SiteNavBar from '../../components/feature/SiteNavBar';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import GallerySection from './components/GallerySection';
import HighlightsSection from './components/HighlightsSection';
import LocationSection from './components/LocationSection';
import ContactSection from './components/ContactSection';
import SiteFooter from '../../components/feature/SiteFooter';
import { propertyData, galleryImages } from '../../mocks/property';
import { useTranslation } from 'react-i18next';

export default function Home() {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen bg-[#FAFAF7]">
      <SiteNavBar />
      <HeroSection name={propertyData.name} location={propertyData.location} slides={propertyData.heroSlides} />
      <PhilosophySection tagline={t('property.tagline')} description={t('property.description')} />
      <GallerySection images={galleryImages} />
      <HighlightsSection highlights={propertyData.highlights} />
      <LocationSection />
      <ContactSection agent={propertyData.agent} />
      <SiteFooter />
    </main>
  );
}
